// removed by extract-text-webpack-plugin
module.exports = {"ContactData":"ContactData__ContactData__1J81r"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Checkout/ContactData/ContactData.css
// module id = 182
// module chunks = 0